/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import styles from './Header.scss';
import baseComponent from '../../decorators/baseComponent';
import Context from '../../Context';
import { Link } from 'react-router';
import Navigation from '../Navigation';
import { connect } from 'react-redux';
import BaseReactComponent from '../Util/BaseReactComponent';
import * as LoginActions from '../../actioncreators/LoginActions';
import { getConfig } from '../settings';
import TouchRipple from 'material-ui/internal/TouchRipple';

@connect(state => ({
  user: state.login.user,
  config: getConfig(state)
}))
@baseComponent(styles)
class Header extends BaseReactComponent {
  navigateBack(backlocation) {
    if (typeof backlocation === 'boolean') {
      this.context.router.goBack();
    } else {
      this.context.router.push(backlocation);
    }
  }

  handleBackendClick = (event, backend) => {
    event.stopPropagation();
    LoginActions.selectBackend(backend)(this.props.dispatch);
  };

  handleDefaultClick = (event, backend) => {
    event.stopPropagation();
    LoginActions.selectDefaultBackend(this.props.user, backend)(this.props.dispatch);

    this.forceUpdate();
  };

  render() {
    let defaultBackend;
    if (this.props.user && typeof localStorage !== 'undefined' && localStorage.getItem !== undefined) {
      defaultBackend = localStorage.getItem('default_config_' + this.props.user.id);
    }
    if (defaultBackend === 'undefined') {
      defaultBackend = undefined;
    }
    if (defaultBackend) {
      defaultBackend = JSON.parse(defaultBackend);
    }

    let backends;
    let backendItems;
    if (this.props.user && this.props.config) {
      backends = this.props.user.backends;
      backendItems = [];

      for (let b = 0; b < backends.length; b++) {
        let current = backends[b];
        let isDefault = defaultBackend && current.customer === defaultBackend.customer;
        if (typeof current.icons !== 'undefined') {
          backendItems.push(
            <div
              key={b}
              className="backend-item"
              onClick={e => {
                this.handleBackendClick(e, current);
              }}>
              <TouchRipple>
                <img
                  className="backend-item-icon"
                  src={current.customer === this.props.config.customer ? current.icons.active : current.icons.normal}
                />
                <div className="backend-item-title">{current.title}</div>
                {typeof localStorage !== 'undefined' ? (
                  <div
                    className={
                      isDefault ? 'backend-item-default backend-item-default-selected' : 'backend-item-default'
                    }
                    onClick={
                      isDefault
                        ? undefined
                        : e => {
                            this.handleDefaultClick(e, current);
                          }
                    }>
                    {isDefault ? this.getIntlMessage('menu.default') : this.getIntlMessage('menu.set_as_default')}
                  </div>
                ) : (
                  undefined
                )}
              </TouchRipple>
            </div>
          );
        }
      }
    }

    return (
      <div className="Header">
        <div className="Header-container container">
          <Navigation className="Header-nav" {...this.props} />

          <div className="Header-title">
            <Link className="Header-brand" to="/">
              <img className="Header-brandImg" src={require('../../public/logo-small.png')} alt="Zehnder logo" />
            </Link>
            <div className="header-product">
              {this.props.config ? (
                <div>
                  <div className="header-product-selection">
                    {typeof this.props.config.icons === 'undefined' ? (
                      undefined
                    ) : (
                      <img
                        className="header-product-selection-image"
                        src={this.props.config.icons.active}
                        srcSet={this.props.config.icons.active.replace('.png', '@2x.png') + ' 2x'}
                      />
                    )}

                    {backends && backends.length > 1 ? <span className="glyphicon glyphicon-menu-down" /> : undefined}
                  </div>

                  {backends && backends.length > 1 ? (
                    <div className="header-product-selection-menu">
                      <div className="header-product-selection-menu-list">{backendItems}</div>
                    </div>
                  ) : (
                    undefined
                  )}
                </div>
              ) : (
                undefined
              )}
              <h1 className="Header-bannerTitle">{this.props.title}</h1>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const types = Header.contextTypes;
Header.propTypes = {
  ...types,
  pageName: React.PropTypes.string,
  showMenu: React.PropTypes.bool
};

Header.contextTypes = {
  ...types,
  router: React.PropTypes.object.isRequired
};

export default Header;



// WEBPACK FOOTER //
// /src/components/Header/Header.js